export default "__VITE_ASSET__CS4Cg0D3__"